import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, VStack } from "native-base";
import { formatMeasuredAtShort } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import Tooltip from "./Tooltip";
import { boxShadow, colors, tooltipCoordContentBox, tooltipCoordText, } from "./useStyles";
export default function MoodTooltip({ tooltip = {
    valueWeight: 0,
    valueBmi: 0,
    valueCircumference: 0,
    measuredAt: new Date(),
    pregnancyWeek: 0,
    graphType: "weight",
}, }) {
    const { t } = useTranslation();
    if (!tooltip)
        return null;
    const { valueWeight, valueCircumference, valueBmi, measuredAt, pregnancyWeek, graphType, } = tooltip;
    const styleTitle = {
        color: colors.black,
        fontSize: 16,
        fontWeight: "500",
        lineHeight: 24,
        marginBottom: 2,
    };
    return (_jsxs(Tooltip, Object.assign({ tooltip: tooltip, styleArrow: { borderTopColor: colors.white }, styleContentBox: Object.assign(Object.assign({}, tooltipCoordContentBox), boxShadow) }, { children: [graphType == "weight" && valueWeight && (_jsxs(VStack, { children: [_jsx(Text, Object.assign({ style: tooltipCoordText }, { children: t("measures:bodyWeight") })), _jsxs(Text, Object.assign({ style: [tooltipCoordText, styleTitle] }, { children: [valueWeight, " kg"] }))] })), graphType == "weight" && valueBmi && (_jsxs(VStack, { children: [_jsx(Text, Object.assign({ style: tooltipCoordText }, { children: "BMI" })), _jsxs(Text, Object.assign({ style: [tooltipCoordText, styleTitle] }, { children: [valueBmi, " kg/m2"] }))] })), graphType == "circumference" && valueCircumference && (_jsx(VStack, { children: _jsxs(Text, Object.assign({ style: [tooltipCoordText, styleTitle] }, { children: [valueCircumference, " cm"] })) })), _jsxs(Text, Object.assign({ style: tooltipCoordText }, { children: [formatMeasuredAtShort(measuredAt), ", ", pregnancyWeek, ". h\u00E9t"] }))] })));
}
